import { render, staticRenderFns } from "./SnackbarAlertNewComponent.vue?vue&type=template&id=d1c6f34a&scoped=true&"
import script from "./SnackbarAlertNewComponent.vue?vue&type=script&lang=ts&"
export * from "./SnackbarAlertNewComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SnackbarAlertNewComponent.vue?vue&type=style&index=0&id=d1c6f34a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c6f34a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VImg,VSnackbar})
